import type { ShareLinkItem } from "./api";

export function demoShareLinksActAvontuur(): ShareLinkItem[] {
  const now = Date.now();
  const week = 7 * 24 * 60 * 60 * 1000;
  return [
    {
      id: "demo-1",
      sid: "demo_sid_ruimtereis_voorbeeld",
      url: "https://act-avontuur.portal.interactggz.nl/demo-link-ruimtereis/",
      code: "voorbeeld-1",
      config: { adventureId: "ruimtereis" },
      expiresAt: new Date(now + 2 * week).toISOString(),
      createdAt: new Date(now - 3 * 24 * 60 * 60 * 1000).toISOString(),
      expired: false,
      result: {
        completed: true,
        resultType: "act-avontuur",
        data: { adventureId: "ruimtereis", adventureLabel: "Ruimtereis" },
        startedAt: new Date(now - 2 * 24 * 60 * 60 * 1000).toISOString(),
        completedAt: new Date(now - 2 * 24 * 60 * 60 * 1000 + 15 * 60 * 1000).toISOString(),
      },
    },
    {
      id: "demo-2",
      sid: "demo_sid_jungle_voorbeeld",
      url: "https://act-avontuur.portal.interactggz.nl/demo-link-jungle/",
      code: "voorbeeld-2",
      config: { adventureId: "jungle" },
      expiresAt: new Date(now + week).toISOString(),
      createdAt: new Date(now - day()).toISOString(),
      expired: false,
      result: null,
    },
    {
      id: "demo-3",
      sid: "demo_sid_verlopen",
      url: "https://act-avontuur.portal.interactggz.nl/demo-link-verlopen/",
      code: null,
      config: { adventureId: "roadtrip" },
      expiresAt: new Date(now - day()).toISOString(),
      createdAt: new Date(now - 3 * week).toISOString(),
      expired: true,
      result: {
        completed: true,
        resultType: "act-avontuur",
        data: { adventureId: "roadtrip", adventureLabel: "Roadtrip naar het surfparadijs" },
        startedAt: new Date(now - 3 * week).toISOString(),
        completedAt: new Date(now - 3 * week + 20 * 60 * 1000).toISOString(),
      },
    },
  ];
}

function day() {
  return 24 * 60 * 60 * 1000;
}

const BLOOM_DEMO_SUMMARY =
  "Acceptatie: In ontwikkeling; Defusie: Al veel kracht; Zelf als context: Veel groeiruimte; Hier en nu: In ontwikkeling; Waarden: Al veel kracht; Waardengericht handelen: In ontwikkeling";

const BLOOM_DEMO_ANSWERS: Record<string, number> = {
  "acceptatie-q1": 2, "acceptatie-q2": 2, "acceptatie-q3": 2,
  "acceptatie-q4": 2, "acceptatie-q5": 2, "acceptatie-q6": 2,
  "defusie-q1": 1, "defusie-q2": 3, "defusie-q3": 1,
  "defusie-q4": 3, "defusie-q5": 1, "defusie-q6": 3,
  "zelfAlsContext-q1": 3, "zelfAlsContext-q2": 3, "zelfAlsContext-q3": 3,
  "zelfAlsContext-q4": 1, "zelfAlsContext-q5": 3, "zelfAlsContext-q6": 1,
  "hierEnNu-q1": 2, "hierEnNu-q2": 4, "hierEnNu-q3": 2,
  "hierEnNu-q4": 2, "hierEnNu-q5": 2, "hierEnNu-q6": 2,
  "waarden-q1": 4, "waarden-q2": 1, "waarden-q3": 4,
  "waarden-q4": 1, "waarden-q5": 4, "waarden-q6": 1,
  "waardengerichtHandelen-q1": 2, "waardengerichtHandelen-q2": 3, "waardengerichtHandelen-q3": 2,
  "waardengerichtHandelen-q4": 3, "waardengerichtHandelen-q5": 2, "waardengerichtHandelen-q6": 3,
};

function bloomDemoData() {
  return { summary: BLOOM_DEMO_SUMMARY, answers: BLOOM_DEMO_ANSWERS };
}

export function demoShareLinksBloom(): ShareLinkItem[] {
  const now = Date.now();
  const week = 7 * 24 * 60 * 60 * 1000;
  return [
    {
      id: "demo-bloom-1",
      sid: "demo_sid_bloom_voltooid_voorbeeld",
      url: "https://bloom.portal.interactggz.nl/demo-link-voltooid/",
      code: "voorbeeld-1",
      config: {},
      expiresAt: new Date(now + 2 * week).toISOString(),
      createdAt: new Date(now - 3 * 24 * 60 * 60 * 1000).toISOString(),
      expired: false,
      result: {
        completed: true,
        resultType: "bloom",
        data: bloomDemoData(),
        startedAt: new Date(now - 2 * 24 * 60 * 60 * 1000).toISOString(),
        completedAt: new Date(now - 2 * 24 * 60 * 60 * 1000 + 10 * 60 * 1000).toISOString(),
      },
    },
    {
      id: "demo-bloom-2",
      sid: "demo_sid_bloom_open_voorbeeld",
      url: "https://bloom.portal.interactggz.nl/demo-link-open/",
      code: "voorbeeld-2",
      config: {},
      expiresAt: new Date(now + week).toISOString(),
      createdAt: new Date(now - day()).toISOString(),
      expired: false,
      result: null,
    },
    {
      id: "demo-bloom-3",
      sid: "demo_sid_bloom_verlopen",
      url: "https://bloom.portal.interactggz.nl/demo-link-verlopen/",
      code: null,
      config: {},
      expiresAt: new Date(now - day()).toISOString(),
      createdAt: new Date(now - 3 * week).toISOString(),
      expired: true,
      result: {
        completed: true,
        resultType: "bloom",
        data: bloomDemoData(),
        startedAt: new Date(now - 3 * week).toISOString(),
        completedAt: new Date(now - 3 * week + 12 * 60 * 1000).toISOString(),
      },
    },
  ];
}
